module.exports = __webpack_public_path__ + "img/crossbowmaster.8c232ba8.png";